import { companyAPI, tariffsAPI } from "Api/api";

import { createSlice } from "@reduxjs/toolkit";

const normalizeTariff = ({ basicCredits, tariffEndDate, moderationCredits, tariff }) => ({
  basicCredits: basicCredits ?? "",
  tariffEndDate: tariffEndDate ?? "",
  moderationCredits: moderationCredits ?? "",
  tariffId: tariff?.id ?? "",
  name: tariff?.name ?? ""
});

const initialState = {
  tariff: {},
  tariffPrice: [],
  services: [],
  creditsServices: [],
  data: {},
  discountData: {},
  currentTariff: {}
};

const subscriptionManagementSlice = createSlice({
  name: "subscriptionManagement",
  initialState,
  reducers: {
    setTariff(state, action) {
      state.tariff = normalizeTariff(action.payload);
    },
    setTariffPrice(state, action) {
      state.tariffPrice = action.payload;
    },
    setServices(state, action) {
      state.services = action.payload;
    },
    setCreditsServices(state, action) {
      state.creditsServices = action.payload;
    },
    setDiscountData(state, action) {
      state.discountData = action.payload;
    },
    setCurrentTariff(state, action) {
      state.currentTariff = action.payload;
    }
  }
});

export const {
  setTariff,
  setTariffPrice,
  setServices,
  setCreditsServices,
  setDiscountData,
  setCurrentTariff
} = subscriptionManagementSlice.actions;

export default subscriptionManagementSlice.reducer;

export const getCompanyById = (id) => (dispatch) => {
  companyAPI
    .getCompanyId(id)
    .then((res) => {
      console.log(res.data);
      dispatch(setTariff(res.data));
      dispatch(setDiscountData(res.data.discount));
      dispatch(setCurrentTariff(res.data.tariff));
    })
    .catch((e) => {
      console.log(e.response);
    });
};

export const getUserTariffs = () => (dispatch) => {
  tariffsAPI
    .getTariffs()
    .then((res) => {
      dispatch(setTariffPrice(res.data));
    })
    .catch((e) => {
      console.log(e.response);
    });
};

export const getServices = () => (dispatch) => {
  tariffsAPI
    .getServices()
    .then((res) => {
      dispatch(setServices(res.data));
    })
    .catch((e) => {
      console.log(e.response);
    });
};

export const getCreditsServices = () => (dispatch) => {
  tariffsAPI
    .getCreditsServices()
    .then((res) => {
      dispatch(setCreditsServices(res.data));
    })
    .catch((e) => {
      console.log(e.response);
    });
};
